import React, { useEffect, useState } from 'react';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { loginRequest } from './authConfig';
import LoginPage from './pages/LoginPage';
import LoginPrompt from "./components/LoginPrompt";
import MainPage from './pages/MainPage';
import TenantList from "./components/TenantList";

async function fetchGroupMembership(accessToken) {
  const response = await fetch('https://graph.microsoft.com/v1.0/me/memberOf', {
    headers: { Authorization: `Bearer ${accessToken}` },
  });

  if (!response.ok) {
    throw new Error(`Fehler bei Graph API: ${response.status}`);
  }

  return await response.json();
}

function App() {
  const { instance, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const [isInGroup, setIsInGroup] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const groupId = process.env.REACT_APP_GROUP_ID;

  useEffect(() => {
    setLoading(true);
    if (!groupId) {
      console.error("REACT_APP_GROUP_ID ist nicht gesetzt.");
      setLoading(false);
      return;
    }

    const checkGroupMembership = async () => {
      if (!accounts?.length) return;

      try {
        const account = accounts[0];
        const response = await instance.acquireTokenSilent({
          ...loginRequest,
          account,
        });

        const groups = await fetchGroupMembership(response.accessToken);
        const isMember = groups.value.some(group => group.id === groupId);
        setIsInGroup(isMember);
      } catch (error) {
        setError('Fehler beim Überprüfen der Berechtigungen');
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    if (isAuthenticated) {
      checkGroupMembership();
    } else {
      setLoading(false);
    }
  }, [accounts, instance, isAuthenticated, groupId]);

  const handleLogin = () => {
    instance.loginRedirect(loginRequest);
  };

  const handleLogout = () => {
    instance.logoutRedirect();
  };

  function AuthWrapper({ children }) {
    if (loading) return <LoginPage><h2>Lädt...</h2></LoginPage>;
    if (!isAuthenticated) return <LoginPage><LoginPrompt handleLogin={handleLogin} /></LoginPage>;
    if (!isInGroup) return <LoginPage><h2>Du bist nicht berechtigt, auf diese Seite zuzugreifen.</h2><button onClick={handleLogout}>Logout</button></LoginPage>;
    return children;
  }

  return (
      <AuthWrapper>
        <MainPage
            headerContent={
              <>
                <span>Willkommen {accounts[0]?.name}</span>
                <button onClick={handleLogout}>Logout</button>
              </>
            }
        >
          <TenantList />
        </MainPage>
      </AuthWrapper>
  );
}

export default App;